<template>
  <div style="margin-top: 2rem">
    <div style="margin-top: 10px;font-weight: 700">服务记录</div>
    <div class="history-table-list">
      <el-table v-loading="recordLoading" :data="lists" style="width: 100%">
        <el-table-column prop="title" label="服务时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.created_at }}
          </template>
        </el-table-column>
        <el-table-column prop="identity" label="角色" align="center">
          <template slot-scope="scope">
            <div
              style="color: #fa8c16"
              v-if="scope.row.identity == 'user'"
            >
              学生
            </div>
            <div style="color: #13c2c2" v-else>老师</div>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="操作" align="center">
          <template slot-scope="scope">
            <div
              style="color: #f56c6c"
              v-if="scope.row.operate_type == '驳回'"
            >
              {{ scope.row.operate_type }}
            </div>
            <div v-else>{{ scope.row.operate_type }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="模块" align="center">
          <template slot-scope="scope">
            {{ scope.row.operation_module }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        align="center"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { log_lists } from '@/api/mycenter_studyabroad'
export default {
  name: "TabSevenTeen",
  components: {

  },
  data() {
    return {
      requestData: {
        page: 1, // 当前页
        paginate: 10, // 分页大小
        user_id: this.$route.query.userId,
        time: "",
        type: 'user', // 只显示学生
        identity: "",
        operator_name: "",
        student_name: "",
        module_type: "", // 模块
        operate_type: "" //操作
      },
      options: [],
      recordLoading: true,
      lists: [], // 数据列表
      page: {
        total: 100000, // 总条数
        currentPage: 1,
      },
    };
  },
  created() {
    this.getList()
  },
  methods: {
    searchAction() {
      this.requestData.page = 1;
      this.getList();
    },
    getList() {
      this.recordLoading = true
      log_lists(this.requestData).then((response) => {
        this.recordLoading = false
        this.lists = (response.data.data || []).map((item, index) => {
          return item;
        });
        this.page.total = response.data.total;
        this.page.currentPage = response.data.current_page;
      }).catch(error=> {
        this.recordLoading = false
        this.$message.error(error.message)
      });
    },
    handleSizeChange(val) {
      this.requestData.paginate = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.requestData.page = val;
      this.getList();
    },
  },
  computed: {
    kModuleTypeOptions() {
      return [
        {
          label: "全部",
          value: null,
        },
        {
          label: "上传",
          value: "上传",
        },
        {
          label: "删除",
          value: "删除",
        },
        {
          label: "修改",
          value: "修改",
        },
        {
          label: "完成",
          value: "完成",
        },
        {
          label: "开始填写",
          value: "开始填写",
        },
        {
          label: "完成初稿",
          value: "完成初稿",
        },
        {
          label: "完成终稿",
          value: "完成终稿",
        },
        {
          label: "更新",
          value: "更新",
        },
        {
          label: "放弃",
          value: "放弃",
        },
        {
          label: "添加",
          value: "添加",
        },
        {
          label: "添加上传任务",
          value: "添加上传任务",
        },
        {
          label: "添加申请结果",
          value: "添加申请结果",
        },
        {
          label: "修改申请结果",
          value: "修改申请结果",
        },
        {
          label: "申请中",
          value: "申请中",
        },
        {
          label: "申请结束",
          value: "申请结束",
        },
        {
          label: "确认",
          value: "确认",
        },
        {
          label: "绑定",
          value: "绑定",
        },
        {
          label: "驳回",
          value: "驳回",
        },
      ];
    },
    kModuleOptions() {
      return [
        {
          label: "全部",
          value: null,
        },
        {
          label: "文书PS",
          value: "文书PS",
        },
        {
          label: "文书RL",
          value: "文书RL",
        },
        {
          label: "文书CV",
          value: "文书CV",
        },
        {
          label: "选校",
          value: "选校",
        },
        {
          label: "CV背景",
          value: "CV背景",
        },
        {
          label: "个人信息",
          value: "个人信息",
        },
        {
          label: "个人陈述Q&A",
          value: "个人陈述Q&A",
        },
        {
          label: "推荐人Q&A",
          value: "推荐人Q&A",
        },
        {
          label: "服务团队",
          value: "服务团队",
        },
        {
          label: "申请信息",
          value: "申请信息",
        },
        {
          label: "申请材料",
          value: "申请材料",
        },
        {
          label: "邮箱",
          value: "邮箱",
        },
      ];
    },
  },

};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_seventeen.vue